export const areAllChildrenImages = (children) => {
  if (!Array.isArray(children)) return false

  return children.every((el) => {
    if (!el.props.item) return false
    const { type, layoutVariant } = el.props.item
    return type === 'image' || layoutVariant === 'isc-image'
  })
}

export const hasColumnOnlyWithImages = (children) => {
  return areAllChildrenImages([children[0]]) || areAllChildrenImages([children[1]])
}

const TOTAL_COLUMNS = 12

export const getTwoColumnRatios = (layoutVariant) => {
  let leftColumnLength = 0

  switch (layoutVariant) {
    case 'isc-two-column-ratio-7-5':
      leftColumnLength = 7
      break
    case 'isc-two-column-ratio-8-4':
      leftColumnLength = 8
      break
    case 'isc-two-column-ratio-4-8':
      leftColumnLength = 4
      break
    case 'isc-two-column-ratio-9-3':
      leftColumnLength = 9
      break
    case 'isc-two-column-ratio-3-9':
      leftColumnLength = 3
      break
    default:
      throw Error(`Layout variant ${layoutVariant} is not supported`)
  }

  return {
    left: {
      small: {
        width: 6,
        offset: 0
      },
      medium: {
        width: leftColumnLength,
        offset: 0
      }
    },
    right: {
      small: {
        width: 6,
        offset: 0
      },
      medium: {
        width: TOTAL_COLUMNS - leftColumnLength,
        offset: 0
      }
    }
  }
}
